export const INSTALLATION_TYPES = {
  sprinkler: 'SPRINKLER',
  fireDetection: 'FIRE_DETECTION',
  firefighterElevator: 'FIREFIGHTER_ELEVATOR',
  smokeControlPressurization: 'SMOKE_CONTROL_PRESSURIZATION',
  mechanicalSmokeHeatExtraction: 'MECHANICAL_SMOKE_HEAT_EXTRACTION',
  publicAdressSystem: 'PUBLIC_ADRESS_SYSTEM',
  fireSafetyControl: 'FIRE_SAFETY_CONTROL',
  other:'OTHER'
} as const;
export type InstallationType = typeof INSTALLATION_TYPES[keyof typeof INSTALLATION_TYPES];

export const INSTALLATION_NECESSITY = {
  mandatory: 'MANDATORY',
  optional: 'OPTIONAL',
} as const;
export type InstallationNecessity = typeof INSTALLATION_NECESSITY[keyof typeof INSTALLATION_NECESSITY];

export interface AnnouncementForm {
  installationType: string;
  necessity: string;
  installationDate: string;
  status: string;
  createdAt: string;
  location?: string;
  lastControlDate?: string;
  designation?: string;
  remarks?: string;
}

export interface TechnicalInstallation {
  id: number;
  installationType: InstallationType;
  necessity: InstallationNecessity;
  installationDate: string;
  status: string;
  createdAt: string;
  location?: string;
  lastControlDate?: string;
  designation?: string;
  remarks?: string;
}
